import { MapPin } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

// J — Facilities / about.
export const Facilities = () => (
  <section id="about" data-testid="about-section" className="on-dark bg-[var(--navy-3)] py-24 text-white sm:py-32">
    <div className="wrap">
      <SectionHead
        dark
        no="07"
        eyebrow="THE PEOPLE AND CAPACITY BEHIND THE PART"
        title={<>Real manufacturing depth. <span className="font-serif-i text-[#9db8ff]">Room for demanding work.</span></>}
        intro="PMP brings machining and programming experience together across manufacturing locations in Colorado and Wyoming."
      />
      <Reveal delay={0.18}>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg [text-wrap:pretty]">
          With 32,000 square feet of combined floor space, our facilities support a range of milling, turning, and multi-axis machining requirements.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-5 lg:grid-cols-[1.15fr_1fr]">
        <Reveal>
          <div className="relative h-full min-h-[20rem] overflow-hidden rounded-[0.75rem] border border-white/10">
            <img
              src="/pmp-facility.jpg"
              alt="Machined metal components (illustrative imagery)"
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-4 bg-gradient-to-t from-black/75 to-transparent p-5 pt-14">
              <p className="font-mono text-[10px] tracking-[0.18em] text-white/85">PMP MANUFACTURING FLOOR</p>
              <p className="font-mono text-[9.5px] tracking-[0.14em] text-white/55">ILLUSTRATIVE IMAGERY</p>
            </div>
          </div>
        </Reveal>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
          {[
            { city: "Fort Collins, Colorado", role: "Company headquarters", sq: "20,000 sq. ft." },
            { city: "Cody, Wyoming", role: "Manufacturing facility", sq: "12,000 sq. ft." },
          ].map((f, i) => (
            <Reveal key={f.city} delay={0.1 + i * 0.08} className="h-full">
              <div data-testid={`facility-card-${i + 1}`} className="card-dark flex h-full flex-col justify-between p-7">
                <MapPin className="h-5 w-5 text-[#9db8ff]" />
                <div className="mt-10">
                  <h3 className="text-lg font-semibold tracking-[-0.01em]">{f.city}</h3>
                  <p className="mt-1 text-[13.5px] text-white/65">{f.role}</p>
                  <p className="mt-4 font-mono text-[11px] tracking-[0.2em] text-[#FFC48C]">{f.sq.toUpperCase()}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.24}>
        <div className="mt-10 flex flex-col items-start justify-between gap-6 rounded-[0.75rem] border border-white/10 bg-white/[0.04] p-8 sm:flex-row sm:items-center sm:p-10">
          <p className="font-serif-i text-2xl sm:text-3xl">Talk to us about the work behind your next part.</p>
          <button
            type="button"
            data-testid="about-connect-button"
            className="btn btn-light shrink-0"
            onClick={() => { const el = document.getElementById("contact"); if (window.__lenis && el) window.__lenis.scrollTo(el, { offset: -90 }); else el?.scrollIntoView({ behavior: "smooth" }); }}
          >
            Connect With PMP
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
